import { useEffect, useRef, useState } from 'react';

import { pollTask } from 'js/utils/usher';

import { ImpactStats } from './types';

type ColdStartFields = {
  paperViews30d: number | null;
  paperViewsTrendPct: number | null;
  paperViewsTotal: number;
};

export function usePaperViewsColdStart(
  impactStats: ImpactStats | null | undefined,
  userId: number | null | undefined,
): ImpactStats | null | undefined {
  const [coldStartFields, setColdStartFields] =
    useState<ColdStartFields | null>(null);
  const invoked = useRef(false);

  const paperViewsCold =
    impactStats != null && impactStats.paperViewsTotal == null;

  useEffect(() => {
    if (!paperViewsCold || userId == null || invoked.current) {
      return;
    }
    invoked.current = true;
    pollTask('nav_paper_views', userId)
      .then((result) => {
        if (result.paperViewsTotal == null) return;
        setColdStartFields({
          paperViews30d: result.paperViews30d,
          paperViewsTrendPct: result.paperViewsTrendPct,
          paperViewsTotal: result.paperViewsTotal,
        });
      })
      .catch(() => undefined);
  }, [paperViewsCold, userId]);

  if (impactStats == null || impactStats.paperViewsTotal != null) {
    return impactStats;
  }
  if (coldStartFields == null) {
    return impactStats;
  }
  return { ...impactStats, ...coldStartFields };
}
